<template>
  <div class="multimedia__content-grid multimedia__content-grid-modal">
    <template>
      <div v-for="(documents, key) in documentsList"
           :key="key">
        <div class="multimedia__content-grid-label"> {{ key }}</div>
        <div class="grid-x grid-margin-x grid-margin-y">
          <div class="cell small-12 medium-6"
               v-for="(document, index) in documents"
               :key="`doc-${index}}`">
            <multimedia-document
              @selected="download"
              :document="document"/>
          </div>
        </div>
      </div>
    </template>
    <a
      ref="fileDownload"
      :href="url"
      :download="filename"
      target="_blank"
      style="display: none;">
    </a>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MultimediaDocument from '@/components/multimedia/items/Document.vue';

export default {
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  components: {
    MultimediaDocument,
  },
  data() {
    return {
      url: null,
      filename: null,
    };
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['getUserMultimedia']),
    documentsList() {
      return this.getMultimedia.multimedia ?? {};
    },
    getMultimedia() {
      return this.getUserMultimedia(this.clientId, 'document') ?? {};
    },
  },
  methods: {
    download(props) {
      if (props.multimedia) {
        this.url = `${props.multimedia.file}?token=${this.token}`;
        this.filename = props.multimedia.filename;

        this.$nextTick(() => {
          this.$refs.fileDownload.click();
        });
      }
    },
  },
};
</script>
